import StepCustomIcon from './StepCustomIcon';
export default StepCustomIcon;
